import axios from 'axios';
import FileSaver from 'file-saver';
import moment from 'moment';
import React, { Component } from 'react';
import {
	Button,
	Col,
	ControlLabel,
	Form,
	FormControl,
	FormGroup,
	Grid,
	Modal,
	Panel,
	ProgressBar,
	Row,
} from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { bindActionCreators } from 'redux';
import socketIOClient from 'socket.io-client';

import { generics } from 'actions';
import { USER_SETUP } from 'actions/const';

import { GENERATE_RANDOM, IS_VALID } from 'utils';

import saveTrail from '../../utils/saveTrail';
import Alert from './Alert';
import FormContainer from './FormContainer';
import Modal_custom from './Modal';
import Table from './Table';

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

const authHeader = () => ({
	'X-Parse-Session-Token': Parse.User.current().getSessionToken(),
});

class UserSetup extends Component {
	constructor(props) {
		super(props);

		this.exportComponentRef = React.createRef();

		this.state = {
			activePage: 1,
			isLoading: false,
			isCUDing: false,
			showModal: false,
			formType: '',
			selectedData: null,
			showAlert: false,
			alertMessage: '',

			showModalExport: false,
		};

		this.stateSetter = this.stateSetter.bind(this);
		this.handlePaginate = this.handlePaginate.bind(this);
		this.getUsers = this.getUsers.bind(this);
		this.createUser = this.createUser.bind(this);
		this.deleteUser = this.deleteUser.bind(this);
		this.accessible = this.accessible.bind(this);
		this.loadOptions = this.loadOptions.bind(this);
	}

	stateSetter(stateArray) {
		for (var i in stateArray) {
			this.setState({ [stateArray[i].state]: stateArray[i].value }, () => {
				if (stateArray[i].state === 'filterUser') {
					this.getAccessList();
				}
			});
		}
	}

	handlePaginate(pageNumber) {
		this.setState({ activePage: pageNumber }, () => {
			this.getUsers();
		});
	}

	getUsers() {
		this.setState({ isLoading: true });

		let { activePage } = this.state;

		let { setValue } = this.props.actions;

		let { limit, filterUsername, filterName, filterMerchant } = this.props.usersetup;

		const getValue = (obj) => (obj == null ? '' : obj.value);

		const params = { page: activePage, limit };
		if (getValue(filterUsername) !== '') params.filterUsername = getValue(filterUsername);
		if (getValue(filterName) !== '') params.filterName = getValue(filterName);
		if (getValue(filterMerchant) !== '') params.filterMerchant = getValue(filterMerchant);

		axios
			.get(WEB_PATH + '/users/list', { params, headers: authHeader() })
			.then(({ data }) => {
				const tableData = data.users.map((u) =>
					Parse.Object.fromJSON({ ...u, className: '_User' })
				);
				setValue(USER_SETUP, 'tableData', tableData);
				setValue(USER_SETUP, 'totalRecord', data.count);
				this.setState({ isLoading: false });
			})
			.catch((err) => {
				console.log('getUsers error: ', err.message);
				this.setState({ isLoading: false });
			});
	}

	createUser() {
		let { selectedData, formType } = this.state;

		let {
			isReprintReceiptEnabled,
			reprintLimit,
			vipMemberList,
			merchant,
			isSendReceiptEmail,
			receiptEmailRecipient,
			isPrintReceiptEnabled,
			evScannerUserList,
			isHideFinanceData,
			isHideClaimedData,
		} = this.props.usersetup;

		const isEmpty = (obj) => (obj === '' ? true : false);
		const isUndefined = (obj) => (typeof obj === 'undefined' ? true : false);

		if (isEmpty(selectedData.get('username')) || isUndefined(selectedData.get('username'))) {
			toast.error('Username is required.');
		} else if (isEmpty(selectedData.get('name')) || isUndefined(selectedData.get('name'))) {
			toast.error('Name is required.');
		} else if (isEmpty(selectedData.get('email')) || isUndefined(selectedData.get('email'))) {
			toast.error('Email is required.');
		} else if (
			isEmpty(selectedData.get('memberId')) ||
			isUndefined(selectedData.get('memberId'))
		) {
			toast.error('Member is required.');
		} else if (
			selectedData.get('userType') === 'MERCHANT' &&
			isReprintReceiptEnabled &&
			IS_VALID(reprintLimit) &&
			parseInt(reprintLimit) <= 0
		) {
			toast.error('Re-print limit should greater than zero');
		} else {
			this.setState({ isCUDing: true, showAlert: false, alertMessage: '' });

			var changesKey = selectedData.dirtyKeys();

			const isExistingUser = IS_VALID(selectedData.id);
			const hasNewPassword = IS_VALID(selectedData.get('password'));

			const body = {
				objectId: selectedData.id || null,
				username: selectedData.get('username'),
				name: selectedData.get('name'),
				email: selectedData.get('email'),
				memberId: selectedData.get('memberId'),
				userType: selectedData.get('userType') || null,
				costCenter: selectedData.get('costCenter') || null,
				password: selectedData.get('password'),
				vipMemberList: vipMemberList.map(({ value }) => value),
				merchant: merchant ? merchant.value : null,
				isSendReceiptEmail,
				receiptEmailRecipient,
				isPrintReceiptEnabled,
				isReprintReceiptEnabled,
				reprintLimit: IS_VALID(reprintLimit) ? parseInt(reprintLimit) : null,
				evScannerUserList: evScannerUserList.map(({ value }) => value),
				isHideFinanceData,
				isHideClaimedData,
				...(isExistingUser && hasNewPassword && { isRequiredToChangePassword: true }),
			};

			axios
				.post(WEB_PATH + '/users/save', body, { headers: authHeader() })
				.then(({ data }) => {
					var changes = {};
					changes.objectId = data.user.objectId;
					changes.name = data.user.name;
					for (var key of changesKey) {
						if (key !== 'password' && key !== 'name') {
							changes[key] = data.user[key];
						}
					}

					saveTrail(formType.toUpperCase(), changes);

					console.log('Creating user: ', data);
					this.getUsers();
					this.setState({
						isCUDing: false,
						showModal: false,
						selectedData: null,
						formType: '',
					});
				})
				.catch((err) => {
					console.log('Creating user error: ', err);
					const error =
						err.response && err.response.data && err.response.data.error
							? err.response.data.error
							: { code: 0, message: err.message };

					if (
						error.code === 200 ||
						error.code === 201 ||
						error.code === 203 ||
						error.code == 202 ||
						error.code === 125
					) {
						this.setState({
							showAlert: true,
							alertMessage: error.message,
							isCUDing: false,
						});
					} else {
						this.setState({
							isCUDing: false,
							showModal: false,
							selectedData: null,
							formType: '',
						});
					}
				});
		}
	}

	deleteUser() {
		this.setState({ isCUDing: true });

		let { selectedData } = this.state;

		axios
			.delete(WEB_PATH + '/users/' + selectedData.id, { headers: authHeader() })
			.then(() => {
				this.getUsers();
				this.setState({
					selectedData: null,
					isCUDing: false,
					showModal: false,
					formType: '',
				});

				saveTrail('DELETE', {
					objectId: selectedData.id,
					username: selectedData.get('username'),
					name: selectedData.get('name'),
					email: selectedData.get('email'),
					memberId: selectedData.get('memberId'),
					userType: selectedData.get('userType'),
				});
			})
			.catch((err) => {
				console.log('Deleting error: ', err);
				this.setState({
					selectedData: null,
					isCUDing: false,
					showModal: false,
					formType: '',
				});
			});
	}

	loadOptions(input, cb, className, columnName, selectedData = null) {
		let { vipMemberList, evScannerUserList } = this.props.usersetup;

		const isUndefined = (obj) => (typeof obj === 'undefined' ? true : false);

		var query = new Parse.Query(className);

		if (typeof columnName === 'string') {
			query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');

			if (className === Parse.User) {
				query.equalTo('userType', 'MERCHANT');
				query.notContainedIn(
					'objectId',
					evScannerUserList.map(({ label, value }) => value)
				);
			}
		} else {
			var queryArray = [];
			for (var column of columnName) {
				var query2 = new Parse.Query(className);
				query2.matches(column, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
				queryArray.push(query2);
			}
			query = Parse.Query.or(...queryArray);

			if (selectedData) {
				query.notEqualTo('objectId', selectedData.id);
				query.notContainedIn(
					'objectId',
					vipMemberList.map(({ label, value }) => value)
				);
				query.doesNotExist('vipHost');
			}
		}

		query.limit(20);
		query
			.find()
			.then((data) => {
				const label = (obj) => {
					if (typeof columnName === 'string') {
						return !isUndefined(obj.get(columnName)) ? obj.get(columnName) : '';
					} else {
						return columnName
							.map((column) => (!isUndefined(obj.get(column)) ? obj.get(column) : ''))
							.join(' ');
					}
				};
				return data.map(
					(item) =>
						(item = {
							label: label(item),
							value: item.id,
						})
				);
			})
			.then((data) => {
				cb(null, { options: data });
			})
			.catch((err) => {
				console.log('loadOptions error: ', err.message);
			});
	}

	accessible(actionType) {
		let { access } = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
				index = access
					.map((module) => module.route.toUpperCase())
					.indexOf(currentPath.toUpperCase()),
				actions = [];

			if (access[index]) {
				actions = access[index].actions;
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
				return 'none';
			}
		} else {
			return 'none';
		}
	}

	render() {
		let {
			activePage,
			isLoading,
			isCUDing,
			showModal,
			formType,
			selectedData,
			showAlert,
			alertMessage,
		} = this.state;

		let { limit, totalRecord } = this.props.usersetup;

		let modalProps = {
			showModal,
			formType,
			stateSetter: this.stateSetter,
			createUser: this.createUser,
			isCUDing,
			deleteUser: this.deleteUser,
			selectedData,
		};

		let paginationProps = {
			activePage: activePage,
			itemsCountPerPage: limit,
			totalItemsCount: totalRecord,
			pageRangeDisplayed: 5,
			onChange: this.handlePaginate,
		};

		let formProps = {
			formType,
			selectedData,
			stateSetter: this.stateSetter,
			loadOptions: this.loadOptions,
		};

		let tableProps = {
			isLoading,
			stateSetter: this.stateSetter,
			getUsers: this.getUsers,
			loadOptions: this.loadOptions,
			accessible: this.accessible,
		};

		let alertProps = {
			stateSetter: this.stateSetter,
			showAlert,
			alertMessage,
		};

		return (
			<Panel>
				<Panel.Heading
					style={{
						backgroundColor: '#D1282F',
						color: 'white',
					}}
				>
					<h4>User Setup</h4>
				</Panel.Heading>
				<Panel.Body>
					<div>
						<Button
							className="btn-primary"
							style={{ display: this.accessible('EXPORT') }}
							onClick={() => {
								if (this.accessible('EXPORT') === '') {
									this.setState({
										showModalExport: true,
									});
								}
							}}
						>
							EXPORT
						</Button>
						&nbsp;
						<Button
							className="btn-primary"
							onClick={() => {
								if (this.accessible('CREATE') === '') {
									var User = Parse.Object.extend(Parse.User),
										user = new User();
									this.stateSetter([
										{ state: 'showModal', value: true },
										{ state: 'formType', value: 'CREATE' },
										{ state: 'selectedData', value: user },
									]);
								}
							}}
							style={{ display: this.accessible('CREATE') }}
						>
							CREATE
						</Button>
					</div>
					<Table {...tableProps} />
					<div>Total Records: {totalRecord}</div>
					<Pagination {...paginationProps} />
					<Modal_custom {...modalProps}>
						<Alert {...alertProps} />
						<FormContainer {...formProps} />
					</Modal_custom>
					<Modal
						bsSize={null}
						backdrop="static"
						show={this.state.showModalExport}
						onHide={() => {
							if (
								this.exportComponentRef.current &&
								this.exportComponentRef.current.isLoading()
							) {
								return;
							}

							this.setState({
								showModalExport: false,
							});
						}}
					>
						<Modal.Header closeButton>
							<Modal.Title>EXPORT USER</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<ExportComponent
								ref={this.exportComponentRef}
								closeModal={() => {
									this.setState({ showModalExport: false });
								}}
							/>
						</Modal.Body>
					</Modal>
					<ToastContainer />
				</Panel.Body>
			</Panel>
		);
	}

	componentDidMount() {
		let { setValue } = this.props.actions;
		this.getUsers();
	}
}

class ExportComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			password: '',

			isExportStarting: false,
			isExporting: false,
			isExportSuccess: false,
			isExportError: false,
			exportPercentage: 0,
			fileConfig: {
				filename: '',
				blob: '',
			},
			errorMessage: '',
		};

		this.exportData = this.exportData.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
		this.isLoading = this.isLoading.bind(this);
	}

	exportData() {
		let { password } = this.state;

		if (!IS_VALID(password) || !IS_VALID(password.trim())) {
			toast.error('Excel File Password is required.');
		} else {
			this.setState({
				isExportStarting: true,
			});

			let params = {
				password: password.trim(),
			};

			axios
				.post(WEB_PATH + '/users/export', params, {
					timeout: 30000,
				})
				.then((res) => {
					let { fileName, socketNspId } = res.data;

					this.setState({
						isExportStarting: false,
						isExporting: true,
					});

					let io = socketIOClient(WEB_PATH, {
						transports: ['websocket'],
						path: '/socket.io',
						query: {
							nspId: socketNspId,
						},
						secure: true,
					});

					let listenerName = 'export-users-socket';

					io.on(listenerName, (data) => {
						let { status, progress, fileName, message } = data;
						if (status === 'PROGRESS') {
							this.setState({
								exportPercentage: progress,
							});
						} else if (status === 'DONE') {
							io.off(listenerName);
							io.close();

							axios
								.get(WEB_PATH + '/users/download/' + fileName, {
									responseType: 'arraybuffer',
								})
								.then((res2) => {
									let blob = new Blob([res2.data], {
											type: 'application/vnd.ms-excel',
										}),
										filename = `Users ${moment().format(
											'MMM DD YYYY hh:mm A'
										)}.xlsx`;

									this.setState({
										isExporting: false,
										isExportSuccess: true,
										exportPercentage: 100,
										fileConfig: {
											filename: filename,
											blob: blob,
										},
									});

									FileSaver.saveAs(blob, filename);
								})
								.catch((err) => {
									let errorMessage = err.message;

									if (
										err.response &&
										err.response.data &&
										'TextDecoder' in window
									) {
										let enc = new TextDecoder('utf-8');
										let arr = new Uint8Array(err.response.data);

										let data = JSON.parse(enc.decode(arr)) || {};

										if (data.error && data.error.message) {
											errorMessage = data.error.message;
										}
									}

									this.setState({
										isExporting: false,
										isExportError: true,
										errorMessage,
									});
								});
						} else if (status === 'ERROR') {
							io.off(listenerName);
							io.close();

							this.setState({
								isExporting: false,
								isExportError: true,
								errorMessage: message,
							});
						}
					});
				})
				.catch((err) => {
					let errorMessage = err.message;

					if (
						err.response &&
						err.response.data &&
						typeof err.response.data === 'string'
					) {
						errorMessage = err.response.data;
					}

					this.setState({
						isExportStarting: false,
						isExportError: true,
						errorMessage,
					});
				});
		}
	}

	downloadFile() {
		let { fileConfig } = this.state;

		let { filename, blob } = fileConfig;

		if (IS_VALID(filename) && IS_VALID(blob)) {
			FileSaver.saveAs(blob, filename);
		}
	}

	isLoading() {
		let { isExportStarting, isExporting } = this.state;

		return isExportStarting || isExporting;
	}

	render() {
		let {
			password,

			isExportStarting,
			isExporting,
			isExportSuccess,
			isExportError,
			exportPercentage,
			errorMessage,
		} = this.state;

		let { closeModal } = this.props;

		return (
			<div>
				{!isExporting && !isExportSuccess && !isExportError
					? [
							<p>
								Exporting of User may take some time depending on the number of
								records.
							</p>,
							<p>
								Note: The export files will be password protected with the
								recommended password below.{' '}
							</p>,
							<Form inline>
								<FormGroup>
									<ControlLabel>
										Recommended Password<span style={{ color: 'red' }}>*</span>
										:&nbsp;
									</ControlLabel>
									<FormControl
										disabled={isExportStarting}
										value={password}
										onChange={(e) => {
											if (!isExportStarting) {
												this.setState({ password: e.target.value });
											}
										}}
									/>
								</FormGroup>
							</Form>,
							<br />,
							<br />,
							<div style={{ textAlign: 'center' }}>
								<Button
									className="btn-primary"
									disabled={isExportStarting}
									onClick={() => {
										this.exportData();
									}}
								>
									{isExportStarting ? (
										<span>
											<i
												className="fa fa-spinner fa-spin"
												style={{ color: 'white' }}
											/>{' '}
										</span>
									) : (
										''
									)}{' '}
									EXPORT
								</Button>
							</div>,
					  ]
					: ''}
				{isExporting ? (
					[
						<p>This may take some time depending on the number of records.</p>,
						<ProgressBar
							active
							striped
							bsStyle="success"
							now={exportPercentage}
							label={`${exportPercentage}%`}
						/>,
					]
				) : isExportSuccess || isExportError ? (
					isExportSuccess ? (
						<div style={{ textAlign: 'center' }}>
							<Button
								bsStyle="success"
								content="DOWNLOAD FILE"
								onClick={this.downloadFile}
							>
								DOWNLOAD FILE
							</Button>
						</div>
					) : (
						[
							<h3 style={{ textAlign: 'center', color: 'red' }}>
								Something went wrong.
							</h3>,
							<h4 style={{ textAlign: 'center' }}>{errorMessage}</h4>,
							<div style={{ textAlign: 'center' }}>
								<Button
									bsStyle="primary"
									onClick={() => {
										closeModal();
									}}
								>
									CLOSE
								</Button>
							</div>,
						]
					)
				) : (
					''
				)}
			</div>
		);
	}

	componentDidMount() {
		this.setState({
			password: GENERATE_RANDOM(10, 'string'),
		});
	}
}

function mapStateToProps(state) {
	var { usersetup, accessjson } = state;
	const props = {
		usersetup,
		accessjson,
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue,
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch),
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSetup);



// WEBPACK FOOTER //
// ./components/UserSetup/index.js